module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('div', {
    class: _vm.classes
  }, [_c('p', {
    staticClass: "dn-db-downloader__lead"
  }, [(_vm.hasNotexist) ? _c('span', [_vm._v("このページを閲覧するには"), _c('wbr'), _vm._v("データのダウンロードが"), _c('wbr'), _vm._v("必要です")]) : _vm._e(), _vm._v(" "), (_vm.hasUpdate) ? _c('span', [_vm._v("このページのデータに"), _c('wbr'), _vm._v("更新があります。")]) : _vm._e(), _vm._v(" "), (_vm.hasMissing) ? _c('span', [_vm._v("データの再ダウンロードが"), _c('wbr'), _vm._v("必要です")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-message"
  }, [(_vm.hasUpdate) ? _c('div', [_c('p', [_vm._v("再度データをダウンロードしてください。")])]) : _vm._e(), _vm._v(" "), (_vm.hasMissing) ? _c('div', [_c('p', [_vm._v("このメッセージが表示される場合以下の原因が考えられます。")]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-actions"
  }, [_c('dn-btn', {
    staticClass: "my-btn-about dn-btn--block-sp",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAbout($event)
      }
    }
  }, [_vm._v("データについて")]), _vm._v(" "), _c('dn-btn', {
    staticClass: "my-btn-download dn-btn--block-sp",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.download($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.hasUpdate ? '更新' : 'ダウンロード') + "する\n    ")])], 1), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-about"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("ダウンロードデータについて")]), _vm._v(" "), _c('div', {
    staticClass: "my-about-data"
  }, [_c('p', [_vm._v("お使いの端末の空き容量が不足している場合、データのダウンロードができない場合があります。"), _c('br'), _vm._v("不要なデータを削除の上再度お試し頂くか、十分な空き容量のある端末でお試しください。")]), _vm._v(" "), _c('p', [_vm._v("一度ダウンロードしたデータは、お使いの端末の空き容量が少なくなった際、ブラウザによって自動的に削除される事があります。"), _c('br'), _vm._v("再度ダウンロードをお試しください。")]), _vm._v(" "), _c('p', [_vm._v("Internet Explorerをお使いの場合、データダウンロード中に画面下部に容量拡張を許可するためのダイアログが表示される事があります。このダイアログが表示された場合「はい」を押して容量の拡張を許可してください。"), _c('br'), _vm._v("この許可を行わずにダイアログを閉じるとダウンロードが行えません。")]), _vm._v(" "), _c('p', [_vm._v("Cookie等のブラウザのストレージ機能を有効にしておかないと、正常にダウンロードできない可能性があります。")]), _vm._v(" "), _c('p', [_vm._v("プライベートブラウズモードでは、正常にダウンロードできない可能性があります。")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticClass: "dn-btn--block-sp",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideAbout($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt10"
  }, [_c('li', [_vm._v("・当サイトを含む過去閲覧されたサイトでの保存データが増えた")]), _vm._v(" "), _c('li', [_vm._v("・お使いの端末のストレージの空き容量が不足した")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-661537c1","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/downloader/DbDownloader.vue
// module id = 344
// module chunks = 1